<script lang="ts" setup>
import SplitButtonPrime, {
  type SplitButtonEmits,
  type SplitButtonProps,
  type SplitButtonSlots,
} from 'primevue/SplitButton'

interface Props extends /* @vue-ignore */ Omit<SplitButtonProps, 'label' | 'icon'> {
  label?: SplitButtonProps['label']
  icon?: SplitButtonProps['icon']
  severity?: SplitButtonProps['severity']
  styleAsInput?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Emits extends /* @vue-ignore */ SplitButtonEmits {}

const props = defineProps<Props>()
defineEmits<Emits>()

const slots = defineSlots<SplitButtonSlots>()
const styleAsInputClasses = [
  'md:px-[var(--p-form-field-padding-x)]',
  'md:py-[var(--p-form-field-padding-y)]',
  'px-[var(--p-form-field-sm-padding-x)]',
  'py-[var(--p-form-field-sm-padding-y)]',
]
</script>

<template>
  <SplitButtonPrime
    v-bind="props"
    :pt="{
      pcButton: {
        root: {
          style: {
            width: 'unset',
          },
          class: styleAsInputClasses
            .filter(() => styleAsInput)
            .concat(['flex-grow'])
            .join(' '),
        },
      },
      pcDropdown: {
        root: {
          style: {
            'border-left': !severity ? '1px solid rgba(255, 255, 255, 0.1) !important' : undefined,
            width: 'unset',
          },
          class: (styleAsInput ? styleAsInputClasses : ['px-2']).join(' '),
        },
      },
    }"
  >
    <template
      v-for="(_, slot) in slots"
      #[slot]="slotData"
    >
      <slot
        :name="slot"
        v-bind="slotData"
      />
    </template>
  </SplitButtonPrime>
</template>
